module.exports = "/_next/static/images/ab4faa103e4ce9030ef28fafb4482457-woman-using-cellphone@1x.jpg";